import React from "react";
import style from "./Options.module.scss";
import { Input } from "reactstrap";

const Filter = ({ selected, range, onChange, description }) => (
  <div className={style.filter}>
    <span className={style.label}>Date</span>
    <Input type="select" value={selected} onChange={(e) => onChange(+e.target.value)} className={style.date}>
      {range.map((settDate, index) => (
        <option key={`set-date-${index}`} value={settDate.id}>
          {new Intl.DateTimeFormat("default", {
            day: "numeric",
            month: "short",
            year: "numeric",
          }).format(new Date(settDate.date))}
        </option>
      ))}
    </Input>

    <span className={style.label} style={{ marginLeft: "10px" }}>
      {description}
    </span>
  </div>
);

export default Filter;
